import { useQuery } from 'react-query';

import { axios } from 'lib';

const getSetupSummary = (resource, id) => {
  return axios.get(`/api/${resource}/${id}/setup/summary`);
};

export const useSetupSummary = (resource, id, options = {}) => {
  return useQuery(
    `${resource}-${id}-setup-summary`,
    () => getSetupSummary(resource, id),
    {
      //@ts-ignore
      initialData: { data: { data: { lots: 0, level_structures: 0, roles: 0, rates: 0 } } },
      select: ({ data }) => data.data,
      ...options,
    }
  );
};
